<template>
  <div class="data-box">
    <div class="flex-box">
      <div class="header-name">
        <label>{{paySlipDataList.length}} {{paySlipType}}</label>
      </div>
      <div class="edit-icon">
        <img src="@/assets/edit.svg" alt @click="editPayslipData(paySlipType)" />
      </div>
    </div>
    <div class="flex-data" v-for="(data,index) of paySlipDataList" :key="index">
      <div class="label-text">{{paySlipType}} {{index+1}}</div>
      <div class="count">
        <p>
          {{data.empCount}}
          <small>Emp</small>
        </p>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    paySlipType: String
  },
  data() {
    return {
      paySlipDataList: [
        {
          empCount: 40
        },
        {
          empCount: 35
        },
        {
          empCount: 55
        }
      ],
      paySlipDataType: ""
    };
  },
  methods: {
    editPayslipData(val) {
      this.paySlipDataType = val;
      //console.log("clicked type val", this.paySlipDataType);
      if (this.paySlipDataType == "PayGroup") {
        this.$router.push({
          path: `/onboarding/entity/${this.$route.params.entity_index}/paygroup`
        });
      }
      if (this.paySlipDataType == "Location") {
        this.$router.push({
          path: `/onboarding/entity/${this.$route.params.entity_index}/locations`
        });
      }
      if (this.paySlipDataType == "Business") {
        this.$router.push({
          path: `/onboarding/entity/${this.$route.params.entity_index}/business_units`
        });
      }
      if (this.paySlipDataType == "BusinessTypes") {
        this.$router.push({
          path: `/onboarding/entity/${this.$route.params.entity_index}/business_units`
        });
      }
      if (this.paySlipDataType == "Cost Center") {
        this.$router.push({
          path: `/onboarding/entity/${this.$route.params.entity_index}/costcenters`
        });
      }

      if (this.paySlipDataType == "Location") {
        this.$router.push({
          path: `/onboarding/entity/${this.$route.params.entity_index}/locations`
        });
      }
      if (this.paySlipDataType == "Business") {
        this.$router.push({
          path: `/onboarding/entity/${this.$route.params.entity_index}/business_units`
        });
      }
      if (this.paySlipDataType == "BusinessTypes") {
        this.$router.push({
          path: `/onboarding/entity/${this.$route.params.entity_index}/business_units`
        });
      }
      if (this.paySlipDataType == "Cost Center") {
        this.$router.push({
          path: `/onboarding/entity/${this.$route.params.entity_index}/costcenters`
        });
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.edit-icon {
  cursor: pointer;
}
.data-box {
  padding: 20px;
  border-radius: 4px;
  box-shadow: 0 1px 6px 0 rgba(0, 0, 0, 0.1);
  background-color: #ffffff;
}
.flex-box {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  border-bottom: solid 1px #37c6c0;
  .header-name {
    label {
      font-weight: 500;
      color: #5d409f;
    }
  }
}
.flex-data {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin: 10px 0px;
  p {
    margin: 0px;
  }
  //  margin: 10px 0px;
}
</style>
